<div class="row banner task-amend">
  <div class="col">
    <h6 class="pt-5px">
      <strong>Configure Governance Document CM9 Mapping</strong>
    </h6>
  </div>
  <div class="col">
    <button (click)="createActivity()" class="btn btn-secondary float-end">
      Create New Document Mapping
    </button>
  </div>
</div>

<form [formGroup]="filterForm" class="search">
  <div class="d-flex justify-content-start">
    <div class="m-0 me-3 w-35">
      <ng-select
        [items]="documentTypes"
        [closeOnSelect]="true"
        [multiple]="false"
        bindLabel="documentTypeName"
        bindValue="id"
        formControlName="documentTypeId"
        [placeholder]="'Document Type'">
      </ng-select>
    </div>
    <div class="m-0 me-3 w-35 d-flex flex-row">
      <button
        (click)="clearFilter()"
        style="height: 29px"
        eosDebounce
        class="btn btn-primary ms-2">
        Clear
      </button>
      <button
        (click)="applyFilter()"
        style="height: 29px"
        eosDebounce
        class="btn btn-primary ms-2">
        Search
      </button>
    </div>
  </div>
</form>

<div class="d-flex table-resp candid-table mt-3" *ngIf="activities.length">
  <table class="table table-bordered table-hover">
    <thead>
      <tr>
        <th [hidden]="true" scope="col">#</th>
        <th scope="col">Document Type</th>
        <th scope="col">Document Value</th>
        <th scope="col">Document Name CM9</th>
        <th scope="col">Active/Inactive</th>
        <th scope="col" class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let act of activities; index as i">
        <td [hidden]="true">{{ i + 1 }}</td>
        <td>{{ act.documentType }}</td>
        <td>{{ act.documentValue }}</td>
        <td>{{ act.documentDisplayText }}</td>
        <td>{{ act.isActive ? 'Active' : 'Inactive' }}</td>
        <td class="text-center">
          <img
            class="cursor-pointer"
            title="Edit mapping"
            (click)="editActivity(act.id)"
            src="design/images/edit.png"
          />
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="card mt-3 text-center d-flex p-5" *ngIf="!activities.length">
  <div class="card-body">No document mappings found</div>
</div>